import omit from 'lodash/omit';
import includes from 'lodash/includes';
import has from 'lodash/has';
import patch from './patch';
import computeAverageFootprint from './computeAverageFootprint';
import { convertValue, ontarioMetricDefaults } from '../selectors/inputs';
import units from '../../lib/units';
import { intitializeFromToken } from './initialize';

const widgetMessageTypes = ['window.resize', 'window.scroll', 'widget.initialize'];

const getOntarioDefaults = (state) => {
  const unitSystem = state.ui.unitSystem;

  return Object.keys(ontarioMetricDefaults).reduce((values, apiKey) => {
    if (!has(state.user_footprint, ['inputs', apiKey])) {
      const uiValue = convertValue(
        apiKey,
        ontarioMetricDefaults[apiKey],
        unitSystem,
        state,
        units.METRIC,
      );
      return {
        ...values,
        [apiKey]: uiValue,
      };
    }
    return values;
  }, {});
};

const isValidUnitSystem = unitSystem => ['standard', 'metric'].indexOf(unitSystem) >= 0;

let widgetInitialized = null;

export default widgetEventData => async (dispatch, getState) => {
  if (!includes(widgetMessageTypes, widgetEventData.type)) {
    return;
  }
  if (widgetEventData.type === 'widget.initialize' && widgetInitialized !== null) {
    return;
  }
  if (!widgetEventData.options) {
    return;
  }
  const options = widgetEventData.options || {};
  if (localStorage.getItem('source') !== options.source) {
    localStorage.clear();
    window.location.reload();
  }
  localStorage.setItem('source', options.source);
  if (options.source !== 'indigo' && options.source !== 'ipl') {
    options.source = 'none';
  }
  widgetInitialized = options.source;
  const update = { ui: { widget: omit(widgetEventData, ['type']) } };
  if (isValidUnitSystem(options.unitSystem)) {
    update.unitSystem = options.unitSystem;
  }
  const { token } = options;
  if (token) {
    update.auth = { token };
    await intitializeFromToken(token)(dispatch, getState);
  }
  dispatch(patch(update));

  if (widgetEventData.type !== 'widget.initialize' || widgetInitialized === options.source) {
    return;
  }

  if (options.source === 'ontario') {
    const updates = {
      user_footprint: {
        inputs: getOntarioDefaults(getState()),
      },
    };

    dispatch(patch(updates));
    computeAverageFootprint({})(dispatch, getState);
  }
};
